/*=========================================================================================
  File Name: module-notification-banner-state.js
  Description: NotificationBanner Module State
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	id: null, //Id của thông báo đang Active (dùng làm key dismiss localStorage)
	isActive: false, //Có thông báo nào đang Bật hay không
	message: '', //Nội dung chữ chạy (plain text) hiển thị trên banner
	messageHtml: '', //Nội dung HTML hiển thị trên popup khi click vào banner
	linkHref: '' //Link đính kèm (nếu có) trong nội dung popup
};
